import { Paper, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function CusDataGrid({
  label,
  rows,
  rowHeight = 36,
  columns,
  onRowClick,
  rowSelectionModel,
  onRowSelectionModelChange,
  labelFontWeight,
  readOnlyCheckBox,
  disableRowSelectionOnClick = true,
  checkboxSelection = true,
  maxHeight,
  minHeight,
  sx
}) {
  const { t } = useTranslation();

  return (
    <Stack display={'flex'} direction={'column'} gap={0}>
      {label && (
        <Typography color="textSecondary" fontWeight={labelFontWeight}>
          {t(label)}
        </Typography>
      )}
      <DataGrid
        rows={rows}
        columns={columns}
        rowHeight={rowHeight}
        checkboxSelection={checkboxSelection}
        hideFooter
        disableColumnMenu
        disableColumnSorting
        disableRowSelectionOnClick={disableRowSelectionOnClick}
        onRowClick={onRowClick}
        rowSelectionModel={rowSelectionModel}
        disableColumnResize
        disableRowSelectionExcludeModel
        disableKeyboardNavigation
        onRowSelectionModelChange={onRowSelectionModelChange}
        sx={{
          maxHeight: maxHeight,
          minHeight: minHeight,
          overflow: 'auto',
          '& .MuiDataGrid-cell:focus': { outline: 'none' },
          '& .MuiDataGrid-cell:focus-within': { outline: 'none' },
          '& .MuiDataGrid-row.Mui-selected': { backgroundColor: 'transparent !important' },
          '& .MuiDataGrid-row:hover': { backgroundColor: 'transparent' },
          '& .MuiDataGrid-columnHeader:focus': { outline: 'none' },
          '& .MuiDataGrid-columnHeader:focus-within': { outline: 'none' },
          '& .MuiDataGrid-columnHeader.Mui-focus': { outline: 'none' },
          '& .MuiDataGrid-columnSeparator': { display: 'none' },
          '& .bold-header *': {
            fontWeight: '600 !important',
            whiteSpace: 'normal',
            fontSize: 14
          },
          ...(readOnlyCheckBox && {
            '& .MuiCheckbox-root': {
              opacity: 0.5,
              pointerEvents: 'none'
            },
            '& .MuiCheckbox-root.Mui-checked': {
              opacity: 1
            },
            '& .MuiDataGrid-columnHeaderTitleContainerContent .MuiCheckbox-root': {
              display: 'none'
            }
          }),

          ...sx
        }}
      />
    </Stack>
  );
}
